import { render, staticRenderFns } from "./userprotocol.vue?vue&type=template&id=5f799ba4&scoped=true"
import script from "./userprotocol.vue?vue&type=script&lang=js"
export * from "./userprotocol.vue?vue&type=script&lang=js"
import style0 from "./userprotocol.vue?vue&type=style&index=0&id=5f799ba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f799ba4",
  null
  
)

export default component.exports